/*global define, console, window, HTMLImageElement, Promise*/
(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("TeamMembersReorderTabs", ["jquery", "Behaviors"], factory);
    } else {
        root.TeamMembersReorderTabs = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    function TeamMembersReorderTabs() {
        Behaviors.init(TeamMembersReorderTabs, this, arguments);
            
        var tabItem = this.$elem.find(TeamMembersReorderTabs.ELEMENTS.tabItemNav);
        var tabContent = this.$elem.find(TeamMembersReorderTabs.ELEMENTS.tabContentSection);

        setTimeout(function() { 
            // var tabContentItemNumber = $(".TeamMembersReorderTabs-content_team_members .HoverStateTeamImagesTabs-content_team_members_member").length;
            // console.log("brpj itema je: " + tabContentItemNumber);
            $('.TeamMembersReorderTabs-content_team_members').each(function() {
                    var $this = jQuery(this);
                    var tabContentItemNumber = $this.find('.HoverStateTeamImagesTabs-content_team_members_member').length;
                    // console.log('Safda u foru je broj itema' + tabContentItemNumber);
                    // alert($('.HoverStateTeamImagesTabs-content_team_members_member', $(this)).length);
                }
            );
        }, 500);

        this.$elem.find(TeamMembersReorderTabs.ELEMENTS.tabItemNav).on('click', function(e){
            e.preventDefault();
            var $this = jQuery(this);
            var href = jQuery(this).attr('href');
            var tab = jQuery(href);
            if(!$this.hasClass('is-TeamMembersReorderTabs-content_team_members--activeTab')) {
                tabContent.hide();
                tab.show();
                tabItem.removeClass('is-TeamMembersReorderTabs-content_tabs_nav_link--activeNav');
                $this.addClass('is-TeamMembersReorderTabs-content_tabs_nav_link--activeNav');
            }
        });

        this.$elem.find(TeamMembersReorderTabs.ELEMENTS.selectTeamMembers).on('change', function(e){
            e.preventDefault();
            var $this = jQuery(this);
            var href = jQuery(this).val();
            var tab = jQuery(href);
            if(!$this.hasClass('is-TeamMembersReorderTabs-content_team_members--activeTab')) {
                tabContent.hide();
                tab.show();
                tabItem.removeClass('is-TeamMembersReorderTabs-content_tabs_nav_link--activeNav');
                $this.addClass('is-TeamMembersReorderTabs-content_tabs_nav_link--activeNav');
            }
        });
        
    }

    Behaviors.inherit(TeamMembersReorderTabs, Behaviors.Behavior);

    TeamMembersReorderTabs.QUERY = "[data-TeamMembersReorderTabs-tabs]";

    TeamMembersReorderTabs.ELEMENTS = {
        tabItemNav: ".TeamMembersReorderTabs-content_tabs_nav a",
        tabContentSection: ".TeamMembersReorderTabs-content_team_members",
        selectTeamMembers: ".TeamMembersReorderTabs-content_filters_item_members",
    };
    
    Behaviors.register_behavior(TeamMembersReorderTabs);
    
    module.TeamMembersReorderTabs = TeamMembersReorderTabs;
    
    return module;
}));
